// Generated from source/ by scripts/generate.ts. Do not edit by hand.
import type { IconData } from "../types.js";

const m0 =
  '<path d="M17 3H21A1 1 0 0 1 22 4V20A1 1 0 0 1 21 21H3A1 1 0 0 1 2 20V4A1 1 0 0 1 3 3H7V1H9V3H15V1H17ZM4 9V19H20V9ZM6 11H8V13H6ZM11 11H13V13H11ZM16 11H18V13H16Z"/>';

/** Calendar (navigation). */
const icon: IconData = {
  id: "calendar",
  name: "Calendar",
  category: "navigation",
  styles: {
    rounded: { svg: m0 },
    sharp: { svg: m0 },
    outline: {
      svg: '<path d="M9 1V3H15V1H17V3H21A1 1 0 0 1 22 4V20A1 1 0 0 1 21 21H3A1 1 0 0 1 2 20V4A1 1 0 0 1 3 3H7V1ZM20 11H4V19H20ZM8 13V15H6V13ZM13 13V15H11V13ZM18 13V15H16V13ZM7 5H4V9H20V5H17V7H15V5H9V7H7Z"/>',
    },
    duotone: {
      svg: '<g opacity=".32"><path d="M9 3H15V1H17V3H21L21.39 3.08 21.71 3.29 21.92 3.61 22 4V20L21.92 20.39 21.71 20.71 21.39 20.92 21 21H3L2.61 20.92 2.29 20.71 2.08 20.39 2 20V4L2.08 3.61 2.29 3.29 2.61 3.08 3 3H7V1H9Z"/></g><path d="M9 1V3H15V1H17V3H21A1 1 0 0 1 22 4V20A1 1 0 0 1 21 21H3A1 1 0 0 1 2 20V4A1 1 0 0 1 3 3H7V1ZM20 11H4V19H20ZM8 13V15H6V13ZM13 13V15H11V13ZM18 13V15H16V13ZM7 5H4V9H20V5H17V7H15V5H9V7H7Z"/>',
    },
  },
  animation: () => import("../animations/calendar.js"),
};

export default icon;
